"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getNavigationTiming;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _performance = require("./performance");

function toNavigationType(navigation) {
  switch (navigation.type) {
    case navigation.TYPE_BACK_FORWARD:
      return 'back_forward';

    case navigation.TYPE_RELOAD:
      return 'reload';

    default:
      return 'navigate';
  }
}

function toNavigationTiming(navigation, timing) {
  function toValue(value) {
    if (value == null) return 0;
    return Math.max(value - timing.navigationStart, 0);
  }

  return {
    connectEnd: toValue(timing.connectEnd),
    connectStart: toValue(timing.connectStart),
    decodedBodySize: 0,
    domainLookupEnd: toValue(timing.domainLookupEnd),
    domainLookupStart: toValue(timing.domainLookupStart),
    domComplete: toValue(timing.domComplete),
    domContentLoadedEventEnd: toValue(timing.domContentLoadedEventEnd),
    domContentLoadedEventStart: toValue(timing.domContentLoadedEventStart),
    domInteractive: toValue(timing.domInteractive),
    duration: toValue(timing.loadEventEnd),
    encodedBodySize: 0,
    entryType: 'navigation',
    fetchStart: toValue(timing.fetchStart),
    initiatorType: 'navigation',
    loadEventEnd: toValue(timing.loadEventEnd),
    loadEventStart: toValue(timing.loadEventStart),
    name: window.location.href,
    nextHopProtocol: '',
    redirectCount: navigation.redirectCount,
    redirectEnd: toValue(timing.redirectEnd),
    redirectStart: toValue(timing.redirectStart),
    requestStart: toValue(timing.requestStart),
    responseEnd: toValue(timing.responseEnd),
    responseStart: toValue(timing.responseStart),
    secureConnectionStart: toValue(timing.secureConnectionStart),
    startTime: 0,
    transferSize: 0,
    type: toNavigationType(navigation),
    unloadEventEnd: toValue(timing.unloadEventEnd),
    unloadEventStart: toValue(timing.unloadEventStart),
    workerStart: 0,
    serverTiming: [],
    toJSON: function toJSON() {
      return this;
    }
  };
}

function getNavigationTiming() {
  // Use the Navigation Timing L2 API if available.
  var _getEntriesByType = (0, _performance.getEntriesByType)(_performance.EntryType.NAVIGATION),
      _getEntriesByType2 = (0, _slicedToArray2.default)(_getEntriesByType, 1),
      navigationTiming = _getEntriesByType2[0];

  if (navigationTiming == null) {
    // Fallback to Navigation Timing L1 API
    if ('timing' in performance && 'navigation' in performance) {
      navigationTiming = toNavigationTiming(performance.navigation, performance.timing);
    }
  }

  return navigationTiming;
}